import axios from "axios";
import { apiServicesUrl } from "./baseUrl";
import { Config } from "../Config";
import { can_visit, userAccessToken } from "../helpers";

export const fetchEasyReferral = (filter) => {
  const {
    page,
    per_page,
    refer_type,
    search_term,
    account_id,
    location_id,
    specialty_id,
    start_date,
    end_date,
    status,
    patient_sex,
    provider_name,
    practice_name,
    practice_mobile_phone,
    practice_street,
    practice_city,
    practice_state,
    patient_insurance_ids,
    speciality_ids,
    order_by,
  } = filter;

  if (account_id === 0) {
    return false;
  }

  let typeParam = refer_type ? `&refer_type=${refer_type}` : "";
  let searchParam = search_term ? `&search_term=${search_term}` : "";
  let startDate = start_date ? `&start_date=${start_date}` : "";
  let endDate = end_date ? `&end_date=${end_date}` : "";
  let referStatus = status ? `&status=${status}` : "";
  let patientSex = patient_sex ? `&patient_sex=${patient_sex}` : "";
  let practiceName = practice_name ? `&practice_name=${practice_name}` : "";
  let providerName = provider_name ? `&provider_name=${provider_name}` : "";
  let practiceMobilePhone = practice_mobile_phone ? `&practice_mobile_phone=${practice_mobile_phone}` : "";
  let practiceStreet = practice_street ? `&practice_street=${practice_street}` : "";
  let practiceCity = practice_city ? `&practice_city=${practice_city}` : "";
  let practiceState = practice_state ? `&practice_state=${practice_state}` : "";
  let orderBy = order_by ? `&order_by=${JSON.stringify(order_by)}` : "";
  let insuranceIds = "";
    if (patient_insurance_ids?.length > 0) {
      insuranceIds = patient_insurance_ids?.map((id) => `&patient_insurance_ids=${id}`)?.join("");
    }
  let specialityIds = "";
    if (speciality_ids?.length > 0) {
      specialityIds = speciality_ids?.map((id) => `&speciality_ids=${id}`)?.join("");
    }
  if (!can_visit("easy_referral")) return
  return axios.get(
    `${apiServicesUrl}/referral/all?account_id=${account_id}&location_id=${location_id}&specialty_id=${specialty_id}&page=${page}&per_page=${per_page}${referStatus}${startDate}${endDate}${insuranceIds}${patientSex}${specialityIds}${practiceName}${providerName}${practiceMobilePhone}${practiceStreet}${practiceCity}${practiceState}${typeParam}${searchParam}${orderBy}`,
    {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    }
  );
};

export const fetchAllSpecialist = async (filter) => {
  const {
    account_id,
    location_id,
    page,
    per_page,
    search_term,
    state,
    type
  } = filter;

  try {
    let searchParam = search_term ? `&search_term=${search_term}` : "";
    let sState = state ? `&state=${state}` : "";
    let sType = type ? `&type=${type}` : "";
    return axios.get(
      `${apiServicesUrl}/npi/all_providers?account_id=${account_id}&location_id=${location_id}&page=${page}&per_page=${per_page}${searchParam}${sState}${sType}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
  } catch (error) {}
};

export const fetchSpecialist = async () => {

  try {
    const result = {data: {
      "results": [
        {
          id: 21,
          name: 'Accident and Emergency Doctor'
        },
        {
          id: 1,
          name: 'Acupuncturist'
        },
        {
          id: 55,
          name: 'Addiction Medicine'
        },
        {
          id: 4,
          name: 'Allergist'
        },
        {
          id: 3,
          name: 'Allergist (Immunologist)'
        },
        {
          id: 7,
          name: 'Assisted Living Facility'
        },
        {
          id: 8,
          name: 'Audiologist'
        },
        {
          id: 9,
          name: 'Behavioral Health Provider'
        },
        {
          id: 56,
          name: 'Cardiologist (Heart Doctor)'
        },
        {
          id: 84,
          name: 'Cardiothoracic Surgeon'
        },
        {
          id: 10,
          name: 'Case Manager'
        },
        {
          id: 11,
          name: 'Chiropractor'
        },
        {
          id: 44,
          name: 'Colorectal Surgery'
        },
        {
          id: 58,
          name: 'Critical Care (Intensivists)'
        },
        {
          id: 5,
          name: 'Dementia Center'
        },
        {
          id: 2,
          name: 'Dentist'
        },
        {
          id: 47,
          name: 'Denturist'
        },
        {
          id: 48,
          name: 'Dermatology'
        },
        {
          id: 19,
          name: 'Developmental Anomaly'
        },
        {
          id: 49,
          name: 'Dietitian / Nutritionist'
        },
        {
          id: 75,
          name: 'Ear, Nose &amp; Throat Doctor (ENT / Otolaryngologist)'
        },
        {
          id: 57,
          name: 'Electrophysiology/EP Specialist'
        },
        {
          id: 20,
          name: 'Emergency Medicine'
        },
        {
          id: 76,
          name: 'Endocrinologist'
        },
        {
          id: 59,
          name: 'Endocrinologist (incl Diabetes Specialists)'
        },
        {
          id: 53,
          name: 'Epilepsy'
        },
        {
          id: 15,
          name: 'Family Planning'
        },
        {
          id: 24,
          name: 'FQHC'
        },
        {
          id: 22,
          name: 'Gastroenterologist'
        },
        {
          id: 82,
          name: 'General Surgery'
        },
        {
          id: 25,
          name: 'Genetics'
        },
        {
          id: 54,
          name: 'Geriatrician'
        },
        {
          id: 26,
          name: 'Hearing Specialist'
        },
        {
          id: 60,
          name: 'Hematologist (Blood Specialist)'
        },
        {
          id: 64,
          name: 'Hepatology'
        },
        {
          id: 36,
          name: 'Imaging Center'
        },
        {
          id: 61,
          name: 'Infectious Disease Specialist'
        },
        {
          id: 27,
          name: 'Infusion Therapy'
        },
        {
          id: 65,
          name: 'Marriage and Family Therapist'
        },
        {
          id: 66,
          name: 'Massage Therapist'
        },
        {
          id: 37,
          name: 'Mobile Imaging Center'
        },
        {
          id: 13,
          name: 'Multi-Specialty Clinic'
        },
        {
          id: 77,
          name: 'Nephrologist'
        },
        {
          id: 23,
          name: 'Nephrologist (Kidney Specialist)'
        },
        {
          id: 43,
          name: 'Neurologist'
        },
        {
          id: 51,
          name: 'Neurologist (incl Headache Specialists)'
        },
        {
          id: 67,
          name: 'Neurosurgeon'
        },
        {
          id: 68,
          name: 'Nuclear Medicine'
        },
        {
          id: 69,
          name: 'Nurse Practitioner'
        },
        {
          id: 70,
          name: 'OB-GYN (Obstetrician-Gynecologist)'
        },
        {
          id: 50,
          name: 'Obesity Medicine'
        },
        {
          id: 29,
          name: 'Occupational Medicine'
        },
        {
          id: 30,
          name: 'Oncologist'
        },
        {
          id: 31,
          name: 'Ophthalmologist'
        },
        {
          id: 71,
          name: 'Optometrist'
        },
        {
          id: 32,
          name: 'Oral Surgeon'
        },
        {
          id: 72,
          name: 'Orthodontist'
        },
        {
          id: 73,
          name: 'Orthopedic Surgeon (Orthopedist)'
        },
        {
          id: 74,
          name: 'Orthotist'
        },
        {
          id: 33,
          name: 'Pain Management Specialist'
        },
        {
          id: 12,
          name: 'Pediatric'
        },
        {
          id: 46,
          name: 'Pediatric Dentist'
        },
        {
          id: 18,
          name: 'Pediatrician'
        },
        {
          id: 78,
          name: 'Pedothrist'
        },
        {
          id: 41,
          name: 'Physiatrist (Physical Medicine)'
        },
        {
          id: 34,
          name: 'Physical Therapist'
        },
        {
          id: 42,
          name: 'Physical Therapy'
        },
        {
          id: 79,
          name: 'Plastic Surgeon'
        },
        {
          id: 6,
          name: 'Podiatrist (Foot and Ankle Specialist)'
        },
        {
          id: 17,
          name: 'Primary Care Physician (PCP)'
        },
        {
          id: 28,
          name: 'Psychiatrist'
        },
        {
          id: 14,
          name: 'Psychologist'
        },
        {
          id: 62,
          name: 'Pulmonologist (Lung Doctor)'
        },
        {
          id: 35,
          name: 'Radiologist'
        },
        {
          id: 38,
          name: 'Rehabilitation'
        },
        {
          id: 63,
          name: 'Rheumatologist'
        },
        {
          id: 39,
          name: 'Sleep Medicine Specialist'
        },
        {
          id: 80,
          name: 'Social Worker'
        },
        {
          id: 81,
          name: 'Specialist'
        },
        {
          id: 52,
          name: 'Sports Medicine Specialist'
        },
        {
          id: 16,
          name: 'Surgeon'
        },
        {
          id: 45,
          name: 'Therapist / Counselor'
        },
        {
          id: 40,
          name: 'Urgent Care Specialist'
        },
        {
          id: 85,
          name: 'Urologist'
        },
        {
          id: 83,
          name: 'Vascular Surgeon'
        }
      ]      
    }};

    return result;
  } catch (error) {}
};

export const fetchSingleReferralData = async ( accountId, locationId, referralId ) => {
  try {
    const response = await axios.get(
      `${apiServicesUrl}/referral/get?account_id=${accountId}&location_id=${locationId}&referral_id=${referralId}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );

    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const deleteReferral = async ( accountId, locationId, referralId ) => {
  try {
    const response = await axios.delete(
      `${apiServicesUrl}/referral/delete?account_id=${accountId}&location_id=${locationId}&referral_id=${referralId}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );

    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const createAndUpdateRefrerral = async (data) => {
  const formData = new FormData();
  Object.keys(data).forEach((key) => {
    if (Array.isArray(data[key])) {
      data[key].forEach((item) => {
        formData.append(key, item); // Handle file arrays or other lists
      });
    } else {
      formData.append(key, data[key]); // For non-file form fields
    }
  });

  try {
    const response = await axios.post(
      `${Config.apiServerUrl}/referral/create`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const EditRefrerralInfo = async (data) => {
  const formData = new FormData();
  Object.keys(data).forEach((key) => {
    if (Array.isArray(data[key])) {
      data[key].forEach((item) => {
        formData.append(key, item); // Handle file arrays or other lists
      });
    } else {
      formData.append(key, data[key]); // For non-file form fields
    }
  });

  try {
    const response = await axios.put(
      `${Config.apiServerUrl}/referral/update`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const updateRefrerralInfo = async (data) => {
  const formData = new FormData();
  Object.keys(data).forEach((key) => {
    if (Array.isArray(data[key])) {
      data[key].forEach((item) => {
        formData.append(key, item); // Handle file arrays or other lists
      });
    } else {
      formData.append(key, data[key]); // For non-file form fields
    }
  });

  try {
    const response = await axios.post(
      `${Config.apiServerUrl}/referral/update`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const getAllUSStates = () => {
  const allStates = [
    { "sort_name": "AL", "name": "Alabama" },
    { "sort_name": "AK", "name": "Alaska" },
    { "sort_name": "AZ", "name": "Arizona" },
    { "sort_name": "AR", "name": "Arkansas" },
    { "sort_name": "CA", "name": "California" },
    { "sort_name": "CO", "name": "Colorado" },
    { "sort_name": "CT", "name": "Connecticut" },
    { "sort_name": "DE", "name": "Delaware" },
    { "sort_name": "FL", "name": "Florida" },
    { "sort_name": "GA", "name": "Georgia" },
    { "sort_name": "HI", "name": "Hawaii" },
    { "sort_name": "ID", "name": "Idaho" },
    { "sort_name": "IL", "name": "Illinois" },
    { "sort_name": "IN", "name": "Indiana" },
    { "sort_name": "IA", "name": "Iowa" },
    { "sort_name": "KS", "name": "Kansas" },
    { "sort_name": "KY", "name": "Kentucky" },
    { "sort_name": "LA", "name": "Louisiana" },
    { "sort_name": "ME", "name": "Maine" },
    { "sort_name": "MD", "name": "Maryland" },
    { "sort_name": "MA", "name": "Massachusetts" },
    { "sort_name": "MI", "name": "Michigan" },
    { "sort_name": "MN", "name": "Minnesota" },
    { "sort_name": "MS", "name": "Mississippi" },
    { "sort_name": "MO", "name": "Missouri" },
    { "sort_name": "MT", "name": "Montana" },
    { "sort_name": "NE", "name": "Nebraska" },
    { "sort_name": "NV", "name": "Nevada" },
    { "sort_name": "NH", "name": "New Hampshire" },
    { "sort_name": "NJ", "name": "New Jersey" },
    { "sort_name": "NM", "name": "New Mexico" },
    { "sort_name": "NY", "name": "New York" },
    { "sort_name": "NC", "name": "North Carolina" },
    { "sort_name": "ND", "name": "North Dakota" },
    { "sort_name": "OH", "name": "Ohio" },
    { "sort_name": "OK", "name": "Oklahoma" },
    { "sort_name": "OR", "name": "Oregon" },
    { "sort_name": "PA", "name": "Pennsylvania" },
    { "sort_name": "RI", "name": "Rhode Island" },
    { "sort_name": "SC", "name": "South Carolina" },
    { "sort_name": "SD", "name": "South Dakota" },
    { "sort_name": "TN", "name": "Tennessee" },
    { "sort_name": "TX", "name": "Texas" },
    { "sort_name": "UT", "name": "Utah" },
    { "sort_name": "VT", "name": "Vermont" },
    { "sort_name": "VA", "name": "Virginia" },
    { "sort_name": "WA", "name": "Washington" },
    { "sort_name": "WV", "name": "West Virginia" },
    { "sort_name": "WI", "name": "Wisconsin" },
    { "sort_name": "WY", "name": "Wyoming" }
  ];

  return allStates;
};

export const updateNpiInformations = (data) => {
  try {
    const response = axios.put(`${apiServicesUrl}/npi/update_provider`, data,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;

  } catch (error) {
    return error?.response?.data;
  }
};


export const fetchInternalSpecialist = async (filter) => {
  const { account_id, speciality_id } = filter;

  try {
    return axios.get(
      `${apiServicesUrl}/npi/internal_provider?account_id=${account_id}&speciality_id=${speciality_id}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
  } catch (error) {}
}